import React from 'react'
import { Link } from 'react-router-dom'
import ForgotPassword from './ForgotPassword'
// import { ajaxPost } from 'api/explus-api';
import WebService from 'api/explus-api';
import Main from '../../Main'

class ForgotPasswordContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({child_id: this.props.match.params.childId})
    }
  }

  handleChange(event) {
    const target = event.target
    const name = target.name
    let value = target.value;

    this.setState({[name]: value})
  }

  handleSubmit(event) {
    event.preventDefault()

    WebService.changePassword(this.state).then(data => {
      // return console.log(data)
    })
  }

  render() {
    return (
      <Main>
        <Link id="edit-submit" className="form-submit" to="/">Return to login</Link>
        <ForgotPassword submit={this.handleSubmit} change={this.handleChange}/>
      </Main>
    )
  }
}

export default ForgotPasswordContainer
